// Keys: connect.SoftphoneErrorTypes values + custom entries (web_socket_connection_lost, missed_call_agent_state)

const callErrorMap = {
  signalling_handshake_failure: "networkError",
  signalling_connection_failure: "networkError",
  ice_collection_timeout: "networkError",
  webrtc_error: "networkError",
  realtime_communication_error: "networkError",
  unsupported_browser: "browserError",
  microphone_not_shared: "micPermissionError",
  gum_timeout_failure: "micPermissionError",
  other: "unexpectedError",
  user_busy_error: "unexpectedError",
  missed_call_agent_state: "missedCallNetworkError",
  web_socket_connection_lost: "networkError",
} as const

type CallErrorMap = typeof callErrorMap

type VoiceCallError = CallErrorMap[keyof CallErrorMap]

const isCallErrorKind = (value: unknown): value is keyof CallErrorMap =>
  typeof value === "string" && value in callErrorMap

/**
 * Resolves the i18n card label for a networking error key, with a safe fallback.
 *
 * @param errorKind - key from {@link callErrorMap}
 * @returns voice call error label used under `callPanel.callErrorCard.*`
 */
const getVoiceCallErrorLabel = (
  errorKind: keyof CallErrorMap,
): VoiceCallError => callErrorMap[errorKind]

export {
  type CallErrorMap,
  getVoiceCallErrorLabel,
  isCallErrorKind,
  type VoiceCallError,
}
